import { useMemo } from 'react';

import { useDefaultEvents } from '@Components/Grid';

export default function useEvents() {
  const { handleDeleteEntry, handleUpdateEntry, handleDuplicateEntry } = useDefaultEvents()

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry])
}
